import React from 'react';
import { SEOHead, LOCAL_BUSINESS_SCHEMA } from '../components/SEOHead';
import { Hero } from '../components/Hero';
import { Outcomes } from '../components/Outcomes';
import { Leak } from '../components/Leak';
import { System } from '../components/System';
import { CTAButton } from '../components/CTAButton';
import { Bloom } from '../components/Bloom';
export function Home() {
  return <>
      <SEOHead title="AI Receptionist + CRM for Phoenix Home-Service Businesses | Viridia Analytics" description="One system that catches every call, text, and Yelp lead for Phoenix contractors. AI receptionist, CRM, and follow-up that runs on its own. Month to month." canonical="/" jsonLd={LOCAL_BUSINESS_SCHEMA} data-id="element-2278" data-mp="1zih29t5e7dcv" />
      <Hero data-id="element-2279" data-mp="2dj1jikvnt149" />
      <Outcomes data-id="element-2280" data-mp="2dfdspthlmst8" />
      <Leak data-id="element-2281" data-mp="3kvk5aj0nqz5g" />
      <System data-id="element-2282" data-mp="3kvtonnr76826" />

      <section className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-2283" data-mp="3ku8sxut5cj2q">
        <Bloom size="lg" className="left-1/2 top-[-16rem] -translate-x-1/2" data-id="element-2284" data-mp="3ow41nkdepyqj" />
        <div className="mx-auto w-full max-w-3xl px-6 py-24 text-center lg:py-28" data-id="element-2285" data-mp="30wjaok4gik28">
          <h2 className="text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-2286" data-mp="30uf7y5ianr3j">
            That&rsquo;s the short version.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-neutral-400" data-id="element-2287" data-mp="2qxaju04w1lk3">
            Here&rsquo;s exactly what runs, and what each piece does for you.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-4" data-id="element-2288" data-mp="2hy75f9go1ubx">
            <CTAButton to="/how-it-works" data-id="element-2289" data-mp="2d7gxboguvddj">See how it works</CTAButton>
            <CTAButton to="/contact" variant="ghost" data-id="element-2290" data-mp="2d5460kp7jqnt">
              Book a 15-min call
            </CTAButton>
          </div>
        </div>
      </section>
    </>;
}